import styled from 'styled-components';

import { grey4 } from 'approot/shared/styles/colours.style';
import { SlideshowContainer } from './slideshow-view.style';

export const SlideshowPrintContainer = styled(SlideshowContainer)`
  border: 1px solid ${grey4};
`;
